import { z } from 'zod';
import type { ZodTypeAny } from 'zod';

/** Wraps any Zod schema to accept undefined or empty string. */
export function optionalOrEmpty<T extends ZodTypeAny>(schema: T) {
  return schema.optional().or(z.literal(''));
}
